// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { useGetApi } from "../client";
import { useCallback } from "react";

export function useRestoreAbladestelle(): (id: string) => Promise<void> {
  const getAPI = useGetApi();
  return useCallback(
    async (id) => (await getAPI()).abladestellen.restoreAbladestelle({ id }),
    [getAPI]
  );
}
